import * as React from 'react';

import type { IconProps } from '../types';

const StatusArchive = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="hsl(var(--twc-status-icon-archive))"
          d="M2.36124 3.79211C2.36124 3.2945 2.76463 2.89111 3.26223 2.89111H12.7378C13.2354 2.89111 13.6388 3.2945 13.6388 3.79211V4.61181C13.6388 5.10942 13.2354 5.51281 12.7378 5.51281H3.26223C2.76463 5.51281 2.36124 5.10942 2.36124 4.61181V3.79211Z"
        />
        <path
          fill="hsl(var(--twc-status-icon-archive))"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6219 6.46484C12.1193 6.46513 12.5226 6.86804 12.5226 7.36547V12.567C12.5223 13.0643 12.1191 13.4674 11.6219 13.4677H4.37811C3.88065 13.4677 3.47772 13.0644 3.47748 12.567V7.36547C3.47748 6.86787 3.8805 6.46484 4.37811 6.46484H11.6219ZM6.66264 8.15886C6.31031 8.15886 6.02431 8.44486 6.02431 8.79718C6.02456 9.14929 6.31047 9.43421 6.66264 9.43421H9.33739C9.68957 9.43421 9.97547 9.14929 9.97572 8.79718C9.97572 8.44486 9.68972 8.15886 9.33739 8.15886H6.66264Z"
        />
      </svg>
    );
  }
);

StatusArchive.displayName = 'StatusArchive';

export { StatusArchive };
